import * as React from 'react';
import { translate } from 'react-i18next';
import { PortalPageSection } from 'components/PortalStructure';
import { ShopData, OrderItems } from 'components';
import * as c from 'models/constants';
import { ICheckoutShopData } from 'models/cart/checkoutshopdata';
import { IShopOrder } from 'models/orders/order';
import { formatCurrency } from 'helpers/common';
import { IProductCardDataAction } from 'models/product/productcard';
import { momentWithTimezone } from 'redux/modules/shop/helpers';
require('./style.css');

interface IProps {
	shopOrders: IShopOrder[];
	t?: (key: string) => string;
	getProductCard?: (id: string, target: string) => IProductCardDataAction;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopOrders extends React.Component<IProps, {}> {
	public render() {
		const { shopOrders, t } = this.props;

		let shopOrdersContent = null;
		if (shopOrders && shopOrders.length > 0) {
			shopOrdersContent = shopOrders.map((shopOrder: IShopOrder) => {
				let shopData: ICheckoutShopData = null;
				const firstItem = shopOrder.items[0];
				if (firstItem) {
					shopData = {
						name: firstItem.shopName,
						location: firstItem.shopLocation,
						picture: firstItem.shopPicture,
					};
				}

				let shippedDate = '/';
				let shippingOptionName = '/';
				let estimatedDelivery = '/';
				const firstShipping = shopOrder.shippings[0];
				const timezone = shopOrder.items[0].officeZoneInfo;

				if (firstShipping) {
					if (firstShipping.shippedDate) {
						shippedDate = momentWithTimezone(timezone, firstShipping.shippedDate).format('L');
						estimatedDelivery = firstShipping.estimatedDeliveryDate
							? momentWithTimezone(timezone, firstShipping.estimatedDeliveryDate).format('L')
							: '/';
					}
					shippingOptionName = firstShipping.shippingOptionName;
				}

				return (
					<div key={shopOrder.id} className="shopOrders">
						<PortalPageSection
							title={t('CodeList_OrderStatus_' + shopOrder.status)}
							description={t('CodeList_OrderStatus_Desc_' + shopOrder.status)}
						/>
						<PortalPageSection>
							<ShopData data={shopData} />
						</PortalPageSection>
						<PortalPageSection>
							<OrderItems
								items={shopOrder.items}
								currencyKey={shopOrder.currencyKey}
								getProductCard={this.props.getProductCard}
							/>
						</PortalPageSection>
						<PortalPageSection>
							<div className="leftContent">{t('Orders_OrderCard_Label_ShippedDate')}:</div>{' '}
							<div className="right">{shippedDate}</div>
							<div className="leftContent">{t('Orders_OrderCard_Label_EstimatedDelivery')}:</div>{' '}
							<div className="right">{estimatedDelivery}</div>
							<div className="leftContent">{t('Orders_OrderCard_Label_DeliveryMethod')}:</div>{' '}
							<div className="right">{shippingOptionName}</div>
						</PortalPageSection>
						<PortalPageSection>
							<div className="subtotalShipping">
								<div className="leftContent">{t('Orders_OrderCard_Label_Subtotal')}:</div>
								<div className="right">{formatCurrency(shopOrder.currencyKey, shopOrder.itemsTotal)}</div>
								<div className="leftContent">{t('Orders_OrderCard_Label_Shipping')}:</div>{' '}
								<div className="right">{formatCurrency(shopOrder.currencyKey, shopOrder.shippingPrice)}</div>
							</div>
						</PortalPageSection>
						<PortalPageSection>
							<div className="totalPriceWrapper">
								{t('Orders_OrderCard_Label_Total')}: {formatCurrency(shopOrder.currencyKey, shopOrder.total)}
							</div>
						</PortalPageSection>
					</div>
				);
			});
		}

		return shopOrdersContent;
	}
}

export { ShopOrders };
